export default {
  setNewsList ({ commit }, payload) {
    commit('setNewsList', payload)
  }
}
